<!-- apps/frontend/src/components/flow/nodes/SendWhatsappNode.vue -->
<template>
  <div :class="['group bg-gray-700 border-2 rounded-lg shadow-lg w-64 relative overflow-visible',
                selected ? 'border-cyan-400' : data.__validationError ? 'border-red-500' : 'border-gray-600']">
    <div class="bg-gray-800 p-3 rounded-t-lg flex items-center gap-2 justify-between">
      <div class="flex items-center gap-2">
        <span class="material-icons text-cyan-400">forum</span>
        <strong class="text-white text-sm">{{ $t('flowEditor.palette.sendWhatsapp') }}</strong>
      </div>
      <ExitNodeBadge :active="data.__isExitNode" />
      <ValidationMarker :error="data.__validationError" />
    </div>
    <div class="p-3 flex flex-col gap-1">
      <span
        v-if="data.interactive === 'buttons' || data.interactive === 'list'"
        class="self-start inline-flex items-center gap-1 text-[10px] uppercase tracking-wide bg-cyan-900/50 text-cyan-300 border border-cyan-700 rounded px-1.5 py-0.5"
      >
        <span class="material-icons" style="font-size:12px;">{{ data.interactive === 'buttons' ? 'smart_button' : 'list' }}</span>
        {{ data.interactive === 'buttons' ? $t('flowEditor.sendWhatsappNode.badgeButtons') : $t('flowEditor.sendWhatsappNode.badgeList') }}
      </span>
      <p class="text-gray-400 text-xs truncate">{{ data.message || '—' }}</p>
    </div>
    <Handle type="target" :position="Position.Left" />
    <Handle type="source" :position="Position.Right" />
    <AddNodeButton v-if="!hasOutgoingEdge" @add="emit('add-node', nodeId)" />
  </div>
</template>
<script setup>
import { Handle, Position } from '@vue-flow/core';
import ExitNodeBadge from './ExitNodeBadge.vue';
import AddNodeButton from './AddNodeButton.vue';
import ValidationMarker from './ValidationMarker.vue';
const emit = defineEmits(['add-node']);
defineProps({
  data:            { type: Object,  required: true },
  selected:        { type: Boolean, default: false },
  nodeId:          { type: String,  required: true },
  hasOutgoingEdge: { type: Boolean, default: false },
});
</script>
